/**
 * AddChildDialog - Dialog to add a child to a customer
 * Extracted from CustomersPage.js
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const AddChildDialog = ({
  open,
  onOpenChange,
  childFormData,
  setChildFormData,
  onAddChild
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Kind hinzufügen</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="child_name">Name des Kindes</Label>
            <Input
              id="child_name"
              value={childFormData.name}
              onChange={(e) => setChildFormData({...childFormData, name: e.target.value})}
              placeholder="z.B. Max Mustermann"
            />
          </div>
          <div>
            <Label htmlFor="child_dob">Geburtsdatum</Label>
            <Input
              id="child_dob"
              type="date"
              value={childFormData.date_of_birth}
              onChange={(e) => setChildFormData({...childFormData, date_of_birth: e.target.value})}
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button 
            onClick={onAddChild}
            disabled={!childFormData.name || !childFormData.date_of_birth}
          >
            Kind hinzufügen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddChildDialog;
